import React, { Component, Fragment } from "react";
import { bool, func, shape, string } from "prop-types";
import { CORPORATE_GROUP_ENVIRONMENT_TYPE } from "constants.js";

import { connect } from "react-redux";
import classNames from "classnames";
import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";
import { selectors as formSelectors } from "reducers/form";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import Notification from "pages/_components/Notification";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import List from "pages/transactions/_components/List";
import HiddenFilters from "pages/transactions/_components/HiddenFilters";
import ProductFilters from "pages/_components/ProductFilters";
import MainContainer from "pages/_components/MainContainer";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import CancelTransactionForm from "./_components/CancelTransactionForm";

const LAST_TRANSACTIONS = "last";
const PREVIOUS_MONTH = "previousMonth";
const ACTUAL_MONTH = "actualMonth";

class PendingTransactionList extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        showHeader: bool,
        isDesktop: bool.isRequired,
        isFirstFetching: bool.isRequired,
        activeEnvironment: shape({ type: string.isRequired }).isRequired,
        isCancellingTransaction: bool.isRequired,
    };

    static defaultProps = {
        showHeader: true,
    };

    state = {
        selectedFilter: LAST_TRANSACTIONS,
        defaultFilters: null,
        filersAreVisible: false,
        transactionToCancel: {},
        openCancelTrxForm: false,
        shouldCleanForm: false,
    };

    loadData = () => {
        const { dispatch } = this.props;
        const dateFrom = new Date();
        dateFrom.setYear(dateFrom.getFullYear() - 1);
        const dateTo = new Date();
        const defaultFilters = {
            dateFrom,
            dateTo,
            pageNumber: 1,
            filter: LAST_TRANSACTIONS,
        };
        this.setState({ defaultFilters });
        dispatch(transactionsActions.loadListRequest(defaultFilters, true, false, true));
    }

    componentDidMount = () => {
        const { dispatch } = this.props;
        dispatch(transactionLinesActions.clearTransactionLines());
        this.loadData();
    };

    handleClickShowFilters = () => {
        this.setState({ filersAreVisible: true });
    };

    handleClickHideFilters = () => {
        this.setState({ filersAreVisible: false });
    };

    handleFilterButtonsClick = (idFilter) => {
        let filters = { filter: idFilter };
        this.setState({ selectedFilter: idFilter });
        switch (idFilter) {
            case LAST_TRANSACTIONS: {
                const dateFrom = new Date();
                dateFrom.setYear(dateFrom.getFullYear() - 1);
                const dateTo = new Date();
                filters = {
                    dateFrom,
                    dateTo,
                    pageNumber: 1,
                    ...filters,
                };
                break;
            }
            case PREVIOUS_MONTH: {
                const dateFrom = new Date();
                dateFrom.setMonth(dateFrom.getMonth() - 1);
                dateFrom.setDate(1);
                const dateTo = new Date();
                dateTo.setDate(0);
                filters = {
                    dateFrom,
                    dateTo,
                    pageNumber: 1,
                    ...filters,
                };
                break;
            }
            case ACTUAL_MONTH: {
                const dateFrom = new Date();
                dateFrom.setDate(1);
                const dateTo = new Date();
                dateTo.setMonth(dateFrom.getMonth() + 1);
                dateTo.setDate(0);
                filters = {
                    dateFrom,
                    dateTo,
                    pageNumber: 1,
                    ...filters,
                };
                break;
            }
            default:
                break;
        }
        const { dispatch } = this.props;
        dispatch(transactionsActions.loadListRequest(filters, true, false, false));
        this.handleClickHideFilters();
    };

    openCancelForm = () => {
        this.setState({ shouldCleanForm: false, openCancelTrxForm: true });
    }

    onCloseCancelForm = () => {
        this.setState({ openCancelTrxForm: false });
    }


    closeAndCleanForm = () => {
        this.setState({ shouldCleanForm: true, openCancelTrxForm: false });
    }

    componentDidUpdate(prevProps) {
        const { isCancellingTransaction } = this.props;
        if (prevProps.isCancellingTransaction !== isCancellingTransaction && !isCancellingTransaction) {
            this.closeAndCleanForm();
            this.loadData();
        }
    }

    render() {
        const { fetching, isDesktop, dispatch, isFirstFetching, activeEnvironment, showHeader } = this.props;
        const { defaultFilters, selectedFilter, filersAreVisible } = this.state;
        const isCorporateGroup = activeEnvironment.type === CORPORATE_GROUP_ENVIRONMENT_TYPE;

        const filters = [
            <CustomButton
                className={classNames("btn btn-outline", {
                    "is-active": selectedFilter === LAST_TRANSACTIONS,
                })}
                key={LAST_TRANSACTIONS}
                text="transactions.list.filter.last"
                textType="I18N"
                func={() => this.handleFilterButtonsClick(LAST_TRANSACTIONS)}
                block={false}
            />,
            <CustomButton
                className={classNames("btn btn-outline", {
                    "is-active": selectedFilter === "actualMonth",
                })}
                key="actualMonth"
                text="transactions.list.filter.actualMonth"
                textType="I18N"
                func={() => this.handleFilterButtonsClick("actualMonth")}
                block={false}
            />,
            <CustomButton
                className={classNames("btn btn-outline", {
                    "is-active": selectedFilter === "previousMonth",
                })}
                key="previousMonth"
                text="transactions.list.filter.previousMonth"
                textType="I18N"
                func={() => this.handleFilterButtonsClick("previousMonth")}
                block={false}
            />,
        ];

        return (
            <Fragment>
                <Notification scopeToShow="transactions" />

                {showHeader && (
                    <CustomProductHead titleId="pendingDispatch.list.title" backLinkTo="/desktop" className="deposits">
                        <div className="toolbar-item view-title">
                            <ViewTitle id="pendingDispatch.list.title" />
                        </div>
                    </CustomProductHead>
                )}
                <MainContainer showLoader={isFirstFetching} showChildrenWithLoader>
                    {showHeader && (
                        <div>
                            <CustomButton
                                className="btn-link show-filters-button-trasactions"
                                func={this.handleClickShowFilters}
                                icon="images/figma/icon/filter.svg"
                                text="global.filter"
                                textType="I18N"
                            />
                        </div>
                    )}
                    <List
                        isDesktop={isDesktop}
                        showSearchButton
                        defaultFilters={defaultFilters}
                        onlyPendings
                        showEnvironment={isCorporateGroup}
                        itemsAreClickeable={!isCorporateGroup}
                        noItemText="transactions.pending.list.none"
                        setTrxToCancel={(trx) => this.setState({ transactionToCancel: trx })}
                        handleOpenCancelForm={() => this.openCancelForm()}
                        isPendingTransactionPage
                    />

                    <Drawer openSidebar={filersAreVisible} toggleSidebar={this.handleClickHideFilters} {...this.props}>
                        <div className="container full-width">
                            <h2>
                                <CustomText text="accounts.movements.filters" textType="I18N" />
                            </h2>
                            <div className="row">
                                <ProductFilters
                                    closeMoreFiltersWhenSiblingClick
                                    moreFilters={
                                        <HiddenFilters
                                            dispatch={dispatch}
                                            isDesktop={isDesktop}
                                            fetching={fetching}
                                            onlyPendings
                                            handleClickHideFilters={this.handleClickHideFilters}
                                        />
                                    }
                                    moreFiltersClosedKeyLabel="accounts.movements.filters.more"
                                    moreFiltersOpenedKeyLabel="accounts.movements.filters.less"
                                    isDesktop={isDesktop}>
                                    {filters}
                                </ProductFilters>
                            </div>
                        </div>
                    </Drawer>
                    <Drawer
                        isDesktop={isDesktop}
                        openSidebar={this.state.openCancelTrxForm}
                        onClose={() => this.closeAndCleanForm()}
                        isFullHeight={!isDesktop}
                        enableCloseButton={!!isDesktop}>
                        <CancelTransactionForm
                            isDesktop={isDesktop}
                            handleClose={this.onCloseCancelForm}
                            openForm={this.state.openCancelTrxForm}
                            transaction={this.state.transactionToCancel}
                            cleanForm={this.state.shouldCleanForm}
                        />
                    </Drawer>
                </MainContainer>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    isFirstFetching: transactionsSelectors.getFirstFetch(state),
    fetching: transactionsSelectors.getFetching(state),
    filters: transactionsSelectors.getFilters(state),
    pageNumber: transactionsSelectors.getPageNumber(state),
    hasMoreData: transactionsSelectors.getHasMoreData(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    isCancellingTransaction: formSelectors.getIsCancellingTransaction(state),
});

export default connect(mapStateToProps)(PendingTransactionList);
